<template>
  <m-contents-wrapper content-type="page" :slicer="slicer">
    <b-container slot-scope="{contents,pagination,changePageFunction}">
      <b-row>
        <b-col lg="4" class="my-2" v-for="content in contents" :key="content.id">
          <m-c302 :image="content.thumbnail" :alt="content.title">
            <template #p-1>
              <m-a :href="{name:'SinglePage',params:{slug:content.slug}}" class="text-dark">
                <h4>{{ content.title }}</h4>
              </m-a>

              <m-a :href="{name:'SinglePage',params:{slug:content.slug}}">
                <b-button class="border-0 text-muted font-weight-bold" variant="transparent" size="sm">
                  <span class="pl-1">بیشتر بخوانید</span>
                  <b-icon icon="arrow-left"/>
                </b-button>
              </m-a>

            </template>
          </m-c302>
        </b-col>
      </b-row>
      <b-row align-h="center" v-if="paginate">
        <b-col lg="12">
          <m-pagination-400 :meta="pagination" :on-change-page="changePageFunction"/>
        </b-col>
      </b-row>
    </b-container>
  </m-contents-wrapper>
</template>

<script>

export default {
  name: "Pages1",
  props: {
    slicer: {
      default: Infinity,
    },
    paginate: {
      default: true,
    },

  },
};
</script>
